<template>
  <span
    v-tooltip.top="{
      value: `${title}`,
      escape: false,
      class: `${customClass}`,
    }"
  >
    <i class="icon-nav-information" :style="{ color: color }" />
  </span>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "Tooltip",

  props: {
    title: { type: String, required: true },
    customClass: { type: String, required: false },
    color: { type: String, default: "var(--insights-color-1)" },
    html: { type: Boolean, default: false },
  },
});
</script>

<style lang="scss">
.p-tooltip-variation {
  .p-tooltip-text {
    width: 250px;
    padding: 12px 18px;
    color: var(--insights-color-2);
    text-align: center;
    background-color: var(--insights-color-1);
    border-radius: 3px;
    font-size: toRem(16px) !important;
    line-height: toRem(18px);
    font-family: "text-medium" !important;

    span {
      font-size: toRem(18px);
      font-family: "text-semi-bold";

      &.up {
        color: var(--insights-color-26);
      }
      &.down {
        color: var(--insights-color-27);
      }
    }
  }
}

.p-tooltip-info {
  .p-tooltip-text {
    width: 320px !important;
    padding: 12px 18px;
    color: var(--insights-color-2);
    text-align: center !important;
    background-color: var(--insights-color-1);
    border-radius: 3px;

    span {
      font-size: toRem(18px);
      font-family: "text-semi-bold";
    }
  }
}
</style>
